import { render, staticRenderFns } from "./LogarithmicSpiral.vue?vue&type=template&id=2fb40700&scoped=true&"
import script from "./LogarithmicSpiral.vue?vue&type=script&lang=js&"
export * from "./LogarithmicSpiral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb40700",
  null
  
)

export default component.exports